/**
 * The choices offered for the theme and the text size, shared by the Display section of the
 * profile settings and the help panel. The values are the ones shared/displayPrefs takes.
 */
const THEME_OPTIONS = [
    {value: 'system', label: 'Same as this device', icon: 'fa-desktop'},
    {value: 'light', label: 'Light', icon: 'fa-sun'},
    {value: 'dark', label: 'Dark', icon: 'fa-moon'},
    {value: 'high-contrast', label: 'High contrast', icon: 'fa-adjust'},
];

// each sample shows its step next to Default, whatever step the page itself is at
const TEXT_SIZE_OPTIONS = [
    {value: 'small', label: 'Small', sample: '0.875em'},
    {value: 'default', label: 'Default', sample: '1em'},
    {value: 'large', label: 'Large', sample: '1.25em'},
    {value: 'larger', label: 'Larger', sample: '1.5em'},
];

export {THEME_OPTIONS, TEXT_SIZE_OPTIONS};
